import styled from 'styled-components';
import { BasePanel } from 'styles/components';
import { Colors } from 'styles/constants';

export const PageContainer = styled(BasePanel)`
  flex-direction: column;
  gap: 24px;
  background: ${Colors.White};
  padding: 24px;
`;
